import { auth, firebase } from '@/extern/firebase';

export function signInWithGoogle(): Promise<firebase.auth.UserCredential> {
  const provider = new firebase.auth.GoogleAuthProvider();
  return auth.signInWithPopup(provider);
}

export function signOut() {
  return auth.signOut();
}
